module.exports = __webpack_public_path__ + "static/media/26.7efed337.png";